import { Navigate, Outlet } from 'react-router-dom';
import { useMe } from '../api/hooks';
import { ErrorState, Loading } from '../components/States';
import { AppShell } from './AppShell';
import { mspNav } from './nav';

export function MspLayout({ mspName }: { mspName: string }) {
  const me = useMe();
  if (me.isPending) return <Loading label="Loading…" />;
  if (me.isError) return <ErrorState error={me.error} retry={() => me.refetch()} />;
  if (!me.data.isMsp) {
    const own = me.data.tenants[0];
    return <Navigate to={own ? `/t/${own.tenantId}/overview` : '/login'} replace />;
  }
  return (
    <AppShell me={me.data} mspName={mspName} sections={[mspNav()]}>
      <div className="page">
        <Outlet />
      </div>
    </AppShell>
  );
}
